import React from 'react';
import Gallery from 'components/Gallery';
import { clothes } from './data/clothes';
import * as S from './styles';

const BottomClothings: React.FC = () => {
  return (
    <S.Container>
      <Gallery clothes={clothes} />
    </S.Container>
  );
};

export default BottomClothings;
